import React from "react";

export const scrollToId = (
  id: string,
  setActiveItem?: React.Dispatch<React.SetStateAction<string>>
) => {
  if (id) {
    const itemId = document.getElementById(id);
    setActiveItem && setActiveItem(id);
    window.scrollTo({
      top:
        (itemId?.getBoundingClientRect().top || 0) + window.pageYOffset - 130,
      behavior: "smooth",
    });
  }
};
